import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { GetScheduledSurveysCacheKey } from '../queries/useGetPlannedSurveys';
import { GetPastSurveyCacheKey } from '../queries/useGetPastSurveys';

export const patchSurveyDeadline = async (
  deadlineInDays: number,
  teamId: number,
  surveyId: number,
) => {
  return axios.patch(`/api/surveys/updateSurveyDeadline/${surveyId}`, {
    deadlineInDays,
    teamId,
  });
};

export enum PatchSurveyDeadlineKey {
  PatchSurveyDeadline = 'PATCH_SURVEY_DEADLINE',
}

export const usePatchSurveyDeadline = (teamId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      teamId,
      surveyId,
      deadlineInDays,
    }: {
      teamId: number;
      surveyId: number;
      deadlineInDays: number;
    }) => patchSurveyDeadline(deadlineInDays, teamId, surveyId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetScheduledSurveysCacheKey.ScheduledSurveys, teamId],
      });
      queryClient.invalidateQueries({
        queryKey: [GetPastSurveyCacheKey.PastSurvey, teamId],
      });
    },
  });
};
